import { createTheme } from '@mui/material';
import { generateColorsVariants, generateThemePalette } from '@vayufp/coast-components';

import { themeOptions as coastThemeOptions } from './coast/theme';
import type { EmbeddedThemeValue } from './types';

function isCustomThemeParams(value: unknown): value is { primaryColor: string; secondaryColor: string } {
  return (
    value !== null &&
    typeof value === 'object' &&
    'primaryColor' in value &&
    'secondaryColor' in value &&
    typeof (value as Record<string, unknown>).primaryColor === 'string' &&
    typeof (value as Record<string, unknown>).secondaryColor === 'string'
  );
}

export function resolveTheme(raw: string | null): EmbeddedThemeValue {
  if (!raw) return { theme: 'coast' };
  try {
    const parsed: unknown = JSON.parse(raw);
    if (isCustomThemeParams(parsed)) {
      return {
        theme: 'custom',
        primaryColor: parsed.primaryColor,
        secondaryColor: parsed.secondaryColor,
      };
    }
  } catch {
    // unparseable theme param — fall through to default
  }

  return { theme: 'coast' };
}

export const buildTheme = (themeMode: EmbeddedThemeValue) =>
  themeMode.theme === 'custom'
    ? createTheme({
        ...coastThemeOptions,
        palette: generateThemePalette(
          generateColorsVariants({
            primaryColor: themeMode.primaryColor,
            secondaryColor: themeMode.secondaryColor,
          }),
        ),
      })
    : createTheme(coastThemeOptions);
